import { motion } from 'framer-motion';
import { Button } from "@/components/ui/button";

interface InitialPageProps {
  onStart: () => void;
}

export function InitialPage({ onStart }: InitialPageProps) {
  return (
    <motion.div
      initial={{ opacity: 0, scale: 0.95 }}
      animate={{ opacity: 1, scale: 1 }}
      exit={{ opacity: 0, scale: 0.95 }}
      transition={{ duration: 0.3 }}
      className="space-y-8"
    >
      <motion.div
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ delay: 0.3 }}
        className="space-y-6"
      >
        <h1 className="text-4xl font-bold text-gray-900">
          suporte grupo TNS
        </h1>
        <p className="text-gray-600 text-lg max-w-xl mx-auto">
          clique no botão para abrir um chamado
        </p>
        <Button
          onClick={onStart}
          className="w-full max-w-md mx-auto bg-gradient-to-r from-[#ffce04] to-[#ff8a47] hover:opacity-90 text-white py-6 text-lg rounded-xl transition-opacity"
        >
          começar →
        </Button>
      </motion.div>
    </motion.div>
  );
}
